import { useEffect, useState } from "react";
import { formatElapsedSeconds } from "@shared/roWorkTimer";

export function useLiveElapsed(startedAt: Date | string | null | undefined, stoppedAt?: Date | string | null) {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    if (stoppedAt) return;
    const timer = window.setInterval(() => setNow(Date.now()), 1000);
    return () => window.clearInterval(timer);
  }, [stoppedAt]);
  if (!startedAt) return "00:00:00";
  const start = new Date(startedAt).getTime();
  const end = stoppedAt ? new Date(stoppedAt).getTime() : now;
  return formatElapsedSeconds(Math.floor(Math.max(0, end - start) / 1000));
}
